import ContextValueProvider from "../../Providers/Value/ContextValueProvider";
import CustomerNotePanelWithPreviousNotes from "../Components/CustomerNotePanelWithPreviousNotes";
import SeriesSeparatorNoteTagsContentBuilder from "../Types/SeriesSeparatorNoteTagsContentBuilder";
import CustomerNoteTagsConfiguration from "./CustomerNoteTagsConfiguration";

const noteTagsContentBuilder = new SeriesSeparatorNoteTagsContentBuilder(" / ");

/** A customer note panel which is provisioned by the session context. */
const ComposedCustomerNotePanel: React.FC = ContextValueProvider({
  Component: CustomerNotePanelWithPreviousNotes,
  map: ({
    appointment,
    customer,
    ignoreNonCan,
    isSearchComplete,
    lead,
    leadDisqualifiers,
    medicalConclusions,
    note,
    previewCustomer,
    selectedCustomer,
    step,
    user,
    setNote
  }) => ({
    currentNoteId: note?.id || null,
    customerId: previewCustomer?.id || selectedCustomer?.id || null,
    disabled: step.isNoteFieldHidden && !isSearchComplete,
    leadId: lead.id,
    noteTagsConfiguration: CustomerNoteTagsConfiguration,
    noteTagsContentBuilder,
    noteTagsProps: {
      medicalConclusions,
      appointment,
      customer,
      ignoreNonCan,
      lead,
      leadDisqualifiers,
      selectedCustomer,
      user
    },
    value: note,
    onChange: setNote
  })
});

export default ComposedCustomerNotePanel;
